import React from "react";
import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
// import Select from 'react-select'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import {}
// import Select from 'react-select';

// import TableDropdown from "components/Dropdowns/TableDropdown.js";

export default function CardTableBukuBesar({
  color,
  tableTitle,
  cols,
  data,
  handleSearch = false,
  pageNumber,
  changePage,
  handleSubmit,
  setData,
  exportPDF,
  isExportable,
  unitUsahaDropdown,
}) {
  const dataPerPage = 10;
  const pageVisited = pageNumber * dataPerPage;

  const displayData = data
    ? data.slice(pageVisited, pageVisited + dataPerPage)
    : [];

  const pageCount = data ? Math.ceil(data.length / dataPerPage) : 0;

  const tanggalSaatIni = new Date().toISOString().slice(0, 10);
  const tanggalAwalTahun = tanggalSaatIni.slice(0, 5) + "01-01";

  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                {tableTitle ? tableTitle : "Tabel"}
              </h3>
            </div>
            <div></div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Date Dropdown */}
          <form onSubmit={handleSubmit}>
            <div className="p-5 w-full">
              <label
                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                htmlFor="tanggal_awal"
                key="tanggal_awal_label"
              >
                Tanggal Awal
              </label>
              <input
                type="date"
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                key="tanggal_awal"
                defaultValue={tanggalAwalTahun}
                onChange={(e) => setData("tanggal_awal", e.target.value)}
              />
            </div>
            <div className="p-5 w-full">
              <label
                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                htmlFor="tanggal_akhir"
                key="tanggal_akhir_label"
              >
                Tanggal Akhir
              </label>
              <input
                type="date"
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                key="tanggal_akhir"
                defaultValue={tanggalSaatIni}
                onChange={(e) => setData("tanggal_akhir", e.target.value)}
              />
            </div>
            {/* <div className="p-5 w-full">
                <label
                  className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="unit_usaha"
                  key="unit_usaha_label"
                >
                  Unit Usaha  
                </label>
                <Select
                 key="id_unit_usaha"
                 className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    onChange={(e) => setData("id_unit_usaha", e.value)}
                    options={unitUsahaDropdown}
                    isSearchable={true}
                  />
              </div> */}

            <div className="p-5 w-full">
              <button
                className="mr-3 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                type="submit"
              >
                Cek
              </button>
              {isExportable && (
                <button
                  className="mr-3 bg-gray-400 text-gray-800 active:bg-red-300 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => exportPDF()}
                >
                  Cetak
                </button>
              )}
            </div>
          </form>

          {/* Search Bar */}
          {handleSearch !== false ? (
            <div className="p-5 w-full">
              <form className="md:flex flex-row flex-wrap items-center lg:ml-auto mr-3">
                <div className="relative flex w-full flex-wrap items-stretch">
                  <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
                    {/* <i className="fas fa-search"></i> */}
                    <i>
                      <FontAwesomeIcon icon="fas fa-search" />
                    </i>
                  </span>
                  <input
                    type="text"
                    placeholder="Search here..."
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
                    onChange={handleSearch}
                  />
                </div>
              </form>
            </div>
          ) : (
            ""
          )}
          {/* Filter Search */}
          {/* <div className="py-2 px-4 mb-2">
                Filter Search By :
                <div className="grid md:flex items-center w-full">
                  <div className="flex-auto">
                    <Select
                      key={'a'}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      onChange={(e) => console.log('on Change')}
                      options={[{label: 'a', value: 'a'}, {label: 'b', value: 'b'}]}
                      // defaultValue={{label: 'a', value: 'a'}}
                      isSearchable={true}
                      placeholder={'Filter Ref...'}
                    />
                  </div>
                  <div className="flex-auto">
                    <Select
                      key={'b'}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      onChange={(e) => console.log('on Change')}
                      options={[{label: 'a', value: 'a'}, {label: 'b', value: 'b'}]}
                      // defaultValue={{label: 'a', value: 'a'}}
                      isSearchable={true}
                      placeholder={'Filter Kode Akun...'}
                    />
                  </div>
                  <div className="flex-auto ">
                    <Select
                      key={'c'}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      onChange={(e) => console.log('on Change')}
                      options={[{label: 'a', value: 'a'}, {label: 'b', value: 'b'}]}
                      // defaultValue={{label: 'a', value: 'a'}}
                      isSearchable={true}
                      placeholder={'Filter N Akun...'}
                    />
                  </div>
                  <div className="flex-auto">
                    <div className="">
                      <button
                        className="mr-3 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={e => {console.log('Filter Search')}}
                      >
                        Filter Search
                      </button>
                    </div>
                  </div>

                </div>
              </div> */}
          {/* Pagination */}
          <div className="py-2 mb-3">
            <nav className="block">
              <div>
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  pageCount={pageCount}
                  onPageChange={changePage}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={1}
                  containerClassName={" flex pl-4 rounded list-none flex-wrap"}
                  activeLinkClassName={
                    "first:ml-0 text-xs font-semibold flex w-8 h-8 p-4 rounded-lg items-center justify-center leading-tight relative border border-solid border-pink-500 text-white bg-pink-500"
                  }
                  previousLinkClassName={
                    "first:ml-0 text-xs font-semibold flex w-8 h-8 p-4 rounded-lg items-center justify-center leading-tight relative border border-solid"
                  }
                  pageLinkClassName={
                    "first:ml-0 text-xs font-semibold flex w-8 h-8 p-0 rounded-full items-center justify-center leading-tight relative border border-solid"
                  }
                  nextLinkClassName={
                    "first:ml-0 text-xs font-semibold flex w-8 h-8 p-4 rounded-lg items-center justify-center leading-tight relative border border-solid"
                  }
                />
              </div>
            </nav>
          </div>

          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  key="0"
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  No
                </th>
                {cols.map((headerItem, index) => (
                  <th
                    key={index + 1}
                    className={
                      "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                      (color === "light"
                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                    }
                  >
                    {headerItem.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayData.length !== 0 ? (
                displayData.map((item, index) => (
                  <tr key={index}>
                    <td
                      key="no"
                      className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                    >
                      {index + 1 + pageVisited}
                    </td>
                    {cols.map((col, key) => (
                      <td
                        key={key}
                        className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                      >
                        {col.render(item)}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr key="0">
                  <td
                    key="empty"
                    className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    Data is Empty
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

CardTableBukuBesar.defaultProps = {
  color: "light",
};

CardTableBukuBesar.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
